import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './UpdateCover.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPageUpdateCoverMutationVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  coverMediaType: Types.EntityPageCoverMediaType;
  coverMediaUploadId?: Types.InputMaybe<Types.Scalars['UploadId']['input']>;
  originalCoverMediaUploadId?: Types.InputMaybe<Types.Scalars['UploadId']['input']>;
}>;


export type EntityPageUpdateCoverMutation = (
  { __typename?: 'Mutation' }
  & { entityPageUpdateCover?: Types.Maybe<(
    { __typename?: 'EntityPageMutationResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'EntityPagesMutationError' }
      & Pick<Types.EntityPagesMutationError, 'errorType' | 'errorCode'>
    )> }
  )> }
);


export type EntityPageUpdateCoverMutationFn = Apollo.MutationFunction<EntityPageUpdateCoverMutation, EntityPageUpdateCoverMutationVariables>;

/**
 * __useEntityPageUpdateCoverMutation__
 *
 * To run a mutation, you first call `useEntityPageUpdateCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityPageUpdateCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityPageUpdateCoverMutation, { data, loading, error }] = useEntityPageUpdateCoverMutation({
 *   variables: {
 *      id: // value for 'id'
 *      coverMediaType: // value for 'coverMediaType'
 *      coverMediaUploadId: // value for 'coverMediaUploadId'
 *      originalCoverMediaUploadId: // value for 'originalCoverMediaUploadId'
 *   },
 * });
 */
export function useEntityPageUpdateCoverMutation(baseOptions?: Apollo.MutationHookOptions<EntityPageUpdateCoverMutation, EntityPageUpdateCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityPageUpdateCoverMutation, EntityPageUpdateCoverMutationVariables>(Operations.EntityPageUpdateCover, options);
      }
export type EntityPageUpdateCoverMutationHookResult = ReturnType<typeof useEntityPageUpdateCoverMutation>;
export type EntityPageUpdateCoverMutationResult = Apollo.MutationResult<EntityPageUpdateCoverMutation>;
export type EntityPageUpdateCoverMutationOptions = Apollo.BaseMutationOptions<EntityPageUpdateCoverMutation, EntityPageUpdateCoverMutationVariables>;